<template>
  <div class="login-container">
    <h1 class="title-e2efee">十堰市数字乡村大屏管理平台</h1>
    <img
      class="page-background"
      src="./img/background.jpg"
      :style="pageBackground"
    />
    <img class="page-box" src="./img/circle.png" :style="pageBox" />
    <div class="box-1">
      <img class="circle-1" src="./img/circle-1.png" :style="circle1" />
      <div v-if="loginFlag" class="from-box">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          autocomplete="on"
          label-position="left"
          v-if="loginType === 'account'"
        >
          <div class="title-container">
            <h3 class="title" @click="accountLogin">账号密码登录</h3>
            <h3 class="title" @click="phoneLogin">手机验证登录</h3>
          </div>
          <div class="account">
            <el-form-item prop="username">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <img class="inputImg" src="./img/shield.png" />
              <el-input
                ref="username"
                v-model="loginForm.username"
                placeholder="用户名"
                name="username"
                type="text"
                tabindex="1"
                autocomplete="on"
              />
            </el-form-item>

            <el-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <el-form-item prop="password">
                <span class="svg-container">
                  <svg-icon icon-class="password" />
                </span>
                <img class="inputImg" src="./img/lock.png" />
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="密码"
                  name="password"
                  tabindex="2"
                  autocomplete="on"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                  @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd" @click="showPwd">
                  <svg-icon
                    :icon-class="
                      passwordType === 'password' ? 'eye' : 'eye-open'
                    "
                  />
                </span>
              </el-form-item>
            </el-tooltip>
            <el-form-item prop="validCode">
              <span class="svg-container">
                <!-- <i class="el-icon-success" /> -->
              </span>
              <img class="inputImg" src="./img/check.png" />
              <el-input
                ref="useryzcode"
                v-model="loginForm.validCode"
                placeholder="请输入验证码"
                name="useryzcode"
                type="num"
                tabindex="3"
                autocomplete="on"
                @keyup.enter.native="handleLogin"
              />
              <div
                v-if="isblock == true"
                class="captcha_code"
                @click="RefreshVcode()"
              >
                <img :src="validateImage" class="Codeimg" />
              </div>
              <el-button
                v-if="isblock != true"
                type=""
                class="yzcode-button"
                @click="obtainCode()"
                >获取验证码</el-button
              >
            </el-form-item>
          </div>

          <el-button
            :loading="loading"
            type="primary"
            class="submit"
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
        </el-form>

        <el-form
          ref="loginPhoneForm"
          :model="loginPhoneForm"
          :rules="loginPhoneRules"
          class="login-form"
          autocomplete="on"
          label-position="left"
          v-else
        >
          <div class="title-container">
            <h3 class="title" @click="accountLogin">账号密码登录</h3>
            <h3 class="title" @click="phoneLogin">手机验证登录</h3>
          </div>
          <el-form-item prop="mobile">
            <span class="svg-container">
              <svg-icon icon-class="user" />
            </span>
            <img class="inputImg" src="./img/shield.png" />
            <el-input
              ref="mobile"
              v-model="loginPhoneForm.mobile"
              placeholder="手机号"
              name="mobile"
              type="text"
              tabindex="1"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="captcha">
            <span class="svg-container">
              <!-- <i class="el-icon-success" /> -->
            </span>
            <img class="inputImg" src="./img/check.png" />
            <el-input
              ref="captcha"
              v-model="loginPhoneForm.captcha"
              placeholder="请输入验证码"
              name="captcha"
              type="num"
              tabindex="3"
              autocomplete="on"
              @keyup.enter.native="handlePhoneLogin"
            />
            <el-button
              :disabled="codeDisabled"
              class="yzcode-button"
              @click="smsCode"
              >{{ showTimer ? time : '获取验证码' }}</el-button
            >
          </el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="submit"
            @click.native.prevent="handlePhoneLogin"
            >登录</el-button
          >
        </el-form>
      </div>

      <div v-else>
        <div class="circle-3" :style="circle3"></div>
        <div class="box-2">
          <img class="box-3" src="./img/gate-shell.png" />
          <img class="light" src="./img/light.png" :style="light" />
          <div class="gate">
            <div class="gate-left" :style="gateLeft"></div>
            <div class="gate-right" :style="gateRight"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { randomWord } from '_s/utils'
import {
  getCode,
  login,
  getSms,
  phoneLogin,
  unlogin,
} from '_s/service/api/login.js'

export default {
  name: 'Login',
  components: {},
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '' || value === undefined || value == null) {
        callback(new Error('用户名不能为空'))
      } else {
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      if (value === '' || value === undefined || value == null) {
        callback(new Error('手机号不能为空'))
      } else {
        if (value.length !== 11) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value === '' || value === undefined || value == null) {
        callback(new Error('密码不能为空'))
      } else {
        if (value.length < 6) {
          callback(new Error('密码格式不正确'))
        } else {
          callback()
        }
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (value === '' || value === undefined || value == null) {
        callback(new Error('验证码不能为空'))
      } else {
        if (value.length !== 6) {
          callback(new Error('验证码格式不正确'))
        } else {
          callback()
        }
      }
    }
    return {
      key: '',
      loginFlag: true, // 是否显示登录框
      loginType: 'account', // 登录类型
      time: 60, // 倒计时
      showTimer: false, // 是否显示倒计时
      codeDisabled: false, // 验证码按钮是否可点击
      pageBackground: {},
      pageBox: {},
      light: {},
      circle1: {},
      circle3: {},
      gateLeft: {},
      gateRight: {},
      loginForm: {
        username: '',
        password: '',
        validCode: '',
      },
      loginPhoneForm: {
        mobile: '',
        captcha: '',
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername },
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword },
        ],
      },
      loginPhoneRules: {
        mobile: [
          { required: true, trigger: 'blur', validator: validateMobile },
        ],
        captcha: [
          { required: true, trigger: 'blur', validator: validateCaptcha },
        ],
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      isblock: false,
      validatecodetaken: '',
      validateImage: '',
    }
  },
  created() {
    this.executeUnlogin() // 执行免登录方法
  },
  mounted() {
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    } else if (this.loginPhoneForm.mobile === '') {
      this.$refs.mobile.focus()
    } else if (this.loginPhoneForm.captcha === '') {
      this.$refs.captcha.focus()
    }
  },

  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    // 后台大屏 内嵌登录
    executeUnlogin() {
      let arr = this.$route.query
      if (arr.username && arr.password) {
        const param = {
          username: arr.username,
          password: arr.password,
        }
        console.log(param)
        unlogin(param).then((res) => {
          if (res.success) {
            sessionStorage.setItem('token', res.result.token)
            sessionStorage.setItem('areacode', arr.areacode)
            this.$router.push(arr.routename)
          } else {
            this.$message({
              type: 'error',
              message: res.message,
            })
            this.loading = false
          }
        })
      }
    },
    /**
     * 获取验证码
     */
    obtainCode() {
      this.key = randomWord()
      getCode(this.key).then((res) => {
        this.validateImage = res.result
        this.isblock = true
      })
    },
    // 获取短信验证码
    smsCode() {
      if (this.loginPhoneForm.mobile === '') {
        this.$message.error('手机号不能为空')
        return
      } else if (this.loginPhoneForm.mobile.length !== 11) {
        this.$message.error('手机号格式不正确')
        return
      } else {
        this.codeDisabled = true
        this.showTimer = true
        const obj = {
          mobile: this.loginPhoneForm.mobile,
          smsmode: '0',
        }
        getSms(obj).then((res) => {
          if (res.success) {
            this.$message.success('短信验证码发送成功')
            this.timer = setInterval(() => {
              if (this.time > 0 && this.time <= 60) {
                this.time--
              } else {
                clearInterval(this.timer)
                this.time = 60
                this.showTimer = false
                this.codeDisabled = false
              }
            }, 1000)
          } else {
            this.codeDisabled = false
            this.showTimer = false
            this.$message.error(res.message)
          }
        })
      }
    },
    // 刷新验证码
    RefreshVcode() {
      this.obtainCode()
    },
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    accountLogin() {
      this.loginType = 'account'
    },
    phoneLogin() {
      this.loginType = 'phone'
    },
    /**
     * 登入
     */
    handleLogin() {
      const that = this
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const param = {
            username: this.loginForm.username,
            password: this.loginForm.password,
            captcha: this.loginForm.validCode,
            checkKey: this.key,
            // username: 'admin',
            // password: '123456'
          }
          login(param).then((res) => {
            if (res.success) {
              // console.log(res,'登录首页')
              // console.log(res.result.tenantList,'首页')
              sessionStorage.setItem('token', res.result.token)
              sessionStorage.setItem(
                'tenantlist',
                JSON.stringify(res.result.tenantList)
              )
              sessionStorage.setItem('tenantId', res.result.userInfo.tenantId)
              sessionStorage.setItem('username', res.result.userInfo.username)
              sessionStorage.setItem('areacode', res.result.userInfo.areacode)
              // sessionStorage.setItem('adminname',res.result.userInfo.areaname);
              //  let areacode =res.result.userInfo.areacode
              //   if(areacode){
              //    sessionStorage.setItem('areacode', areacode.split(",")[0]);
              //    sessionStorage.setItem('multiareacode',areacode)
              //  }
              if (res.result.userInfo.realname == '管理员') {
                this.timer = setTimeout(this.waitAdminTime, 2000)
              } else if (res.result.userInfo.realname !== '管理员') {
                this.timer = setTimeout(this.waitTime, 2000)
              }
              that.loading = false
              this.loginFlag = false
              let aidlist = JSON.parse(
                JSON.stringify(res.result.tenantList)
              ).map((val) => {
                return val.areacode
              })
              let firstname = JSON.parse(
                JSON.stringify(res.result.tenantList)
              ).map((val) => {
                return val.name
              })
              let addressList = JSON.parse(
                JSON.stringify(res.result.tenantList)
              ).map((val) => {
                return val.lon + ',' + val.lat
              })
              // 根据;分割字符串

              if (res.result.tenantList[0].shp) {
                let limitShp = res.result.tenantList[0].shp.split(';')
                let leftBottomShp = limitShp[0]
                let rightTopShp = limitShp[1]
                let leftTopShp = limitShp[2]
                let rightBottomShp = limitShp[3]
                sessionStorage.setItem('leftBottomShp', leftBottomShp)
                sessionStorage.setItem('rightTopShp', rightTopShp)
                sessionStorage.setItem('leftTopShp', leftTopShp)
                sessionStorage.setItem('rightBottomShp', rightBottomShp)
              }

              // console.log(addressList[0],'位置信息')
              sessionStorage.setItem('addressList', addressList[0])
              if (aidlist.length) {
                sessionStorage.setItem('areacode', aidlist[0])
                sessionStorage.setItem('adminname', firstname[0])
              }
              this.pageBackground = {
                // width:"20%",
                animation: 'background-move 10s linear infinite',
                // animation: "background-move 10s linear infinite;"
              }
              this.pageBox = {
                animation: 'rotate 3s linear 1s reverse infinite',
              }
              this.circle1 = {
                animation: 'rotate1 3s linear 1s reverse infinite',
              }
              this.circle3 = {
                animation: 'rotate 3s linear 1s reverse infinite',
              }
              this.gateLeft = {
                animation: 'background-move1 3s',
                animationFillMode: 'forwards',
              }
              this.gateRight = {
                animation: 'background-move 3s ',
                animationFillMode: 'forwards',
              }
              this.light = {
                display: 'block;',
              }
            } else {
              this.$message({
                type: 'error',
                message: res.message,
              })
              that.loginForm.validCode = ''
              this.obtainCode()
              this.loading = false
            }
          })
          //add 20220531
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handlePhoneLogin() {
      const that = this
      this.$refs.loginPhoneForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const param = {
            mobile: this.loginPhoneForm.mobile,
            captcha: this.loginPhoneForm.captcha,
            remember_me: true,
          }
          phoneLogin(param).then((res) => {
            if (res.code === 200) {
              sessionStorage.setItem('token', res.result.token)
              sessionStorage.setItem('areacode', res.result.userInfo.areacode)
              sessionStorage.setItem('tenantId', res.result.userInfo.tenantId)

              this.timer = setTimeout(this.waitTime, 2000)
              that.loading = false
              this.loginFlag = false
              this.pageBackground = {
                // width:"20%",
                animation: 'background-move 10s linear infinite',
                // animation: "background-move 10s linear infinite;"
              }
              this.pageBox = {
                animation: 'rotate 3s linear 1s reverse infinite',
              }
              this.circle1 = {
                animation: 'rotate1 3s linear 1s reverse infinite',
              }
              this.circle3 = {
                animation: 'rotate 3s linear 1s reverse infinite',
              }
              this.gateLeft = {
                animation: 'background-move1 3s',
                animationFillMode: 'forwards',
              }
              this.gateRight = {
                animation: 'background-move 3s ',
                animationFillMode: 'forwards',
              }
              this.light = {
                display: 'block;',
              }
            } else {
              this.$message({
                type: 'error',
                message: res.message,
              })
              that.loginForm.validCode = ''
              this.obtainCode()
              this.loading = false
            }
          })
          //add 20220531
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async waitTime() {
      this.$router.push({
        path: '/',
      })
    },
    async waitAdminTime() {
      this.$router.push({
        path: 'shareMap',
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
  },
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

// $bg: #283443;
// $light_gray: #fff;
// $cursor: #fff;
//modify 20220531
$bg: #fffdfd;
$light_gray: rgb(4, 4, 4);
$cursor: rgb(0, 0, 0);

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  //add 20220531
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;

  .title-e2efee {
    position: relative;
    z-index: 999;
    margin-bottom: 25px;
    font-size: 64px;
    color: white;
  }

  .page-background {
    position: absolute;
    left: 0;
    width: 200%;
    height: 100%;
    background-size: 50% 100%;
    z-index: 1;
    // animation: background-move 10s linear infinite;
  }

  .page-box {
    width: 605px;
    height: 605px;
    margin-top: 2%;
    margin-left: 0%;
    // animation: rotate 3s linear 1s reverse infinite;
    z-index: 2;
  }
  .box-1 {
    width: 525px;
    height: 525px;
    margin-top: -565px;
    margin-left: 0%;
    z-index: 3;
    .circle-1 {
      width: 525px;
      height: 525px;
      margin-left: 0%;
      z-index: 3;
      // animation: rotate1 3s linear 1s reverse infinite;
    }
    .circle-3 {
      width: 460px;
      height: 460px;
      margin-top: -95%;
      margin-left: 6%;
      background: url(./img/circle-2.png) no-repeat top center / auto 100%;
      z-index: 3;
      // animation: rotate 3s linear 1s reverse infinite;
    }
    .box-2 {
      margin-top: -470px;
      margin-left: 25px;
      .box-3 {
        width: 420px;
        height: 420px;
        padding-top: 60px;
        padding-left: 55px;
        z-index: 3;
        position: relative;
      }
      .light {
        margin-top: -600px;
        margin-left: -480px;
        transition-timing-function: ease-in-out;
        z-index: 3;
        display: block;
      }
    }
    .gate {
      width: 400px;
      margin-top: -480px;
      margin-left: 90px;

      .gate-left {
        width: 150px;
        height: 150px;
        float: left;
        margin-left: -60px;
        background: url(./img/gate-left.png) no-repeat top center / auto 100%;
        // animation: background-move1 3s;
        z-index: 0;
      }
      .gate-right {
        width: 150px;
        height: 150px;
        float: right;
        margin-right: 50px;
        background: url(./img/gate-right.png) no-repeat top center / auto 100%;
        // animation: background-move 3s;
        z-index: 1;
      }
    }

    .from-box {
      width: 450px;
      height: 450px;
      border-radius: 50%; //圆角百分比
      border: 5px solid rgba(0, 245, 255, 0.8);
      background: rgba(14, 164, 192, 0.5);
      opacity: 0.85;
      margin-top: -490px;
      margin-left: 40px;
      z-index: 3;
    }
  }

  .el-input {
    display: inline-block;
    height: 40px;
    width: 75%;
    padding-left: 20px;
    padding-top: 5px;

    input {
      background: transparent;
      border: 1px solid white;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 40px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: $bg;
    border-radius: 25px;
    color: #454545;
    margin-top: -10px;
    margin-left: 8%;
    width: 85%;
  }
  .el-form-item__content {
    display: flex;
  }
  .submit {
    border-radius: 25px;
    box-shadow: inset -3px -3px 5px rgba(0, 0, 0, 0.5);
    font-size: 24px;
    color: white;
    padding: 5px 3em;
    border: none;
    margin-top: 8px;
    margin-left: 25%;
    background: rgba(87, 235, 255, 0.993);
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    // padding: 160px 35px 0;
    //modify 20220531
    padding: 100px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  .inputImg {
    width: 20px;
    height: 30px;
    margin-top: 12px;
  }

  .title-container {
    position: relative;
    display: flex;
    align-items: center;

    .title {
      font-size: 18px;
      flex: 1;
      height: 50px;
      color: $light_gray;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }
  .captcha_code {
    height: 45px;
    margin: 5px 10px 0 0;
  }
  .Codeimg {
    width: 100px;
    border-radius: 5px;
    padding: 2px;
  }

  .yzcode-button {
    margin: 5px;
  }
  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>

<style>
@keyframes bling {
  0%,
  50%,
  100% {
    opacity: 0.6;
  }
  25% {
    opacity: 1;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}

@keyframes rotate1 {
  100% {
    transform: rotate(-1turn);
  }
}
@keyframes background-move {
  100% {
    transform: translateX(-50%);
  }
}
@keyframes background-move1 {
  100% {
    transform: translateX(50%);
  }
}
</style>
